import $ from "jquery";


function MainNav() {
    document.addEventListener("DOMContentLoaded", this._init.bind(this));
}

MainNav.prototype._init = function () {
    $('.nav-button').on('click', function () {
        $('body').toggleClass('menu-is-open');
    });
};


module.exports = new MainNav();


// WEBPACK FOOTER //
// ./source/assets/scripts/nav.js